export default ({
  data: {
    result: { id },
  },
}) => {
  return [{ customerID: id }];
};
